import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M31.72 24.012c0-4.406.18-9.148.537-14.225a5.668 5.668 0 0 1 1.545-3.513H12.208c-1.763 0-3.21 1.587-3.56 3.692-.483 2.918-.874 8.338-.874 14.04 0 4.074.248 9.62.744 16.633l1.055-1.055a2.66 2.66 0 0 1 3.541-.198l2.094 1.672a.887.887 0 0 0 1.108 0l2.208-1.77a2.66 2.66 0 0 1 3.332.004l2.193 1.764a.887.887 0 0 0 1.108.004l2.247-1.788a2.66 2.66 0 0 1 3.31-.001l1.74 1.38a190.647 190.647 0 0 1-.734-16.64ZM37.93 4.5a5.321 5.321 0 0 1 5.321 5.321v6.209a2.66 2.66 0 0 1-2.66 2.66h-3.548a.887.887 0 1 1 0-1.773h3.547c.49 0 .887-.397.887-.887V9.82a3.548 3.548 0 0 0-3.547-3.547 3.912 3.912 0 0 0-3.903 3.637c-.355 5.038-.532 9.738-.532 14.1 0 5.457.242 10.952.727 16.485a1.774 1.774 0 0 1-2.87 1.544l-1.739-1.38a.887.887 0 0 0-1.103 0l-2.248 1.788a2.66 2.66 0 0 1-3.324-.01l-2.193-1.765a.887.887 0 0 0-1.11 0l-2.209 1.769a2.66 2.66 0 0 1-3.324.002l-2.094-1.672a.887.887 0 0 0-1.18.066l-1.055 1.055a1.774 1.774 0 0 1-3.023-1.13C6.249 33.714 6 28.129 6 24.006c0-5.793.398-11.309.899-14.329.478-2.883 2.567-5.176 5.31-5.176h25.72ZM12.21 16.917a.887.887 0 0 1 0-1.774h8.867a.887.887 0 1 1 0 1.774h-8.868Zm12.416 0a.887.887 0 0 1 0-1.774h3.546a.887.887 0 1 1 0 1.774h-3.546Zm-12.417 5.321a.887.887 0 0 1 0-1.774h8.868a.887.887 0 1 1 0 1.774h-8.868Zm12.417 0a.887.887 0 0 1 0-1.774h3.546a.887.887 0 0 1 0 1.774h-3.546ZM12.208 27.56a.887.887 0 0 1 0-1.774h8.868a.887.887 0 1 1 0 1.773h-8.868Zm12.417 0a.887.887 0 0 1 0-1.774h3.546a.887.887 0 0 1 0 1.773h-3.546Zm-12.417 5.32a.887.887 0 0 1 0-1.774h8.868a.887.887 0 1 1 0 1.774h-8.868Zm12.417 0a.887.887 0 0 1 0-1.774h3.546a.887.887 0 0 1 0 1.774h-3.546Z",
      clipRule: "evenodd"
    }
  )
);
var SvgInvoiceOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InvoiceOutlined_default = SvgInvoiceOutlined;

export { InvoiceOutlined_default as default };
